import type { AxiosInstance } from 'axios';
import createOffer from './offer';
import createOrder from './order';
import createCommon from './common';
import createWatchList from './watchList';
import createSecure from './secure';
import createCollection from './collection';
import createNft from './nft';
import createDrop from './drop';

export class ApiService {
    private readonly axiosInstance: AxiosInstance;

    public readonly nft: ReturnType<typeof createNft>;
    public readonly drop: ReturnType<typeof createDrop>;
    public readonly collection: ReturnType<typeof createCollection>;
    public readonly offer: ReturnType<typeof createOffer>;
    public readonly order: ReturnType<typeof createOrder>;
    public readonly watchList: ReturnType<typeof createWatchList>;
    public readonly secure: ReturnType<typeof createSecure>;
    public readonly common: ReturnType<typeof createCommon>;

    constructor(axiosInstance: AxiosInstance) {
        this.axiosInstance = axiosInstance;
        this.secure = createSecure(this.axiosInstance);
        this.common = createCommon(this.axiosInstance);
        this.watchList = createWatchList(this.axiosInstance);
        this.offer = createOffer(this.axiosInstance);
        this.nft = createNft(this.axiosInstance);
        this.drop = createDrop(this.axiosInstance);
        this.order = createOrder(this.axiosInstance);
        this.collection = createCollection(this.axiosInstance);
    }
}

export type EvmApi = ApiService;
